<template>
  <div class="body">
    <div class="bg-main">
      <section class="vh-100 gradient-custom">
        <div class="container py-5 h-100">
          <div
            class="row d-flex justify-content-center align-items-center h-100"
          >
            <div class="col-12 col-md-8 col-lg-6 col-xl-5">
              <div class="card bg-white text-black" style="border-radius: 1rem">
                <div class="card-body p-5 text-start">
                  <div class="mb-md-5 mt-md-4">
                    <img
                      alt="Paxelmarket logo"
                      width="250"
                      src="@/assets/paxelmarket_admin.png"
                    />

                    <p class="fw-bold mb-2 fsize-32">Log in</p>
                    <p class="text-black-50 mb-5 fsize-14">
                      Welcome back! Please enter you details bellow
                    </p>

                    <template v-if="enableGoogle != 'true'">
                      <div class="form-outline form-white mb-4">
                        <label
                          class="fw-bold form-label fsize-14"
                          for="typeUsernameX"
                          >Username</label
                        >
                        <input
                          type="text"
                          v-model="username"
                          id="typeUsernameX"
                          class="form-control form-control"
                          placeholder="Example: admin"
                        />
                      </div>

                      <div class="form-outline form-white mb-2">
                        <label
                          class="fw-bold form-label fsize-14"
                          for="typePasswordX"
                          >Password</label
                        >
                        <input
                          type="password"
                          v-model="password"
                          id="typePasswordX"
                          class="form-control form-control"
                          placeholder="Enter your password"
                          @keyup.enter="login"
                        />
                      </div>
                      <div class="form-check mb-4">
                        <input
                          class="form-check-input form-remember-me"
                          type="checkbox"
                          id="flexCheckDefault"
                          v-model="isRemember"
                        />
                        <label
                          class="form-check-label fsize-12"
                          for="flexCheckDefault"
                        >
                          Remember me
                        </label>
                      </div>
                      <button
                        class="btn btn-lg full-width btn-login text-uppercase mb-4"
                        @click="login()"
                      >
                        Log In
                      </button>              
                    </template>

                    <!-- CUSTOM BUTTON -->
                    <button v-else @click="handleClickGoogle" class="gsi-material-button">
                      <div class="gsi-material-button-state"></div>
                      <div class="gsi-material-button-content-wrapper">
                        <div class="gsi-material-button-icon">
                          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block;">
                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path>
                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path>
                            <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path>
                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path>
                            <path fill="none" d="M0 0h48v48H0z"></path>
                          </svg>
                        </div>
                        <span class="gsi-material-button-contents">Sign in with Google</span>
                        <span style="display: none;">Sign in with Google</span>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      isRemember: false,
      buttonEl: null,
      enableGoogle: process.env.VUE_APP_ENABLE_GOOGLE_LOGIN
    };
  },
  components: {},
  computed: {
    isGoogleInit() {
      return this.$store.state.isGoogleInit;
    },
  },
  watch: {
    isGoogleInit(val) {
      if (val && window.google) {
        this.renderGoogleLogin()
      }
    },
  },
  methods: {
    renderGoogleLogin () {
      window.google.accounts.id.prompt();

      const googleLoginWrapper = document.createElement("div");
      // Or you can simple hide it in CSS rule for custom-google-button
      googleLoginWrapper.style.display = "none";
      googleLoginWrapper.classList.add("custom-google-button");

      // Add the wrapper to body
      document.body.appendChild(googleLoginWrapper);

      // const googleEl = document.getElementById("google-login");
      const googleEl = googleLoginWrapper;
      if (googleEl) {
        // console.log("RENDER BUTTON");
        // button will not showing, show the custom button instead
        // this google button is hard to customize because it renderen on iframe
        window.google.accounts.id.renderButton(
          googleEl,
          {
            type: "standard",
            theme: "outline",
            size: "large",
            text: "sign_in_with",
            logo_alignment: "left",
            width: "300"
          } // customization attributes
        );

        this.buttonEl = googleLoginWrapper.querySelector("div[role=button]")
      }
    },
    handleClickGoogle() {
        if(this.buttonEl) this.buttonEl.click()
    },
    async login() {
      try {
        const payload = {
          username: this.username,
          password: this.password,
        };

        await this.$store.dispatch("retrieveToken", payload);
        this.$router.push({
          name: "Home",
        });
        this.$swal({
          icon: "success",
          title: "Welcome Back !!",
          text: "PaxelMarket CMS 3.0",
          showConfirmButton: false,
          timer: 1500,
        });
        if (this.isRemember) {
          localStorage.setItem("remember_username", this.username);
        } else {
          localStorage.removeItem("remember_username");
        }
      } catch (err) {
        console.log(err);
        this.$swal({
          icon: "error",
          title: "Oops...",
          text: "Wrong Username or Password",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },
  },
  mounted() {
    if(this.isGoogleInit) {
      this.renderGoogleLogin()
    }
    const rememberVal = localStorage.getItem("remember_username");
    if (rememberVal) {
      this.username = rememberVal;
      this.isRemember = true;
    }
    if (this.$route.query?.expired) {
      this.$swal({
        icon: "error",
        title: "Token Expired",
        text: "Your Session has Ended",
        showConfirmButton: false,
        timer: 2500,
      });
      this.$router.replace("/login");
    }
  },
};
</script>

<style>
.body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.bg-main {
  background-color: #fdd1d4;
  width: 100%;
  height: 100%;
  margin: 0;
}

form {
  margin: auto;
  border: 1px solid red;
  display: table;
}

.full-width {
  width: 100%;
}

.btn-login {
  background-color: #ff434f;
  color: #ffffff;
  font-size: 16px;
}

.form-remember-me:checked {
  background-color: #ffc334;
  border-color: #ffc334;
}

.gsi-material-button {
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -webkit-appearance: none;
  background-color: WHITE;
  background-image: none;
  border: 1px solid #747775;
  -webkit-border-radius: 4px;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #1f1f1f;
  cursor: pointer;
  font-family: 'Roboto', arial, sans-serif;
  font-size: 14px;
  height: 40px;
  letter-spacing: 0.25px;
  outline: none;
  overflow: hidden;
  padding: 0 12px;
  position: relative;
  text-align: center;
  -webkit-transition: background-color .218s, border-color .218s, box-shadow .218s;
  transition: background-color .218s, border-color .218s, box-shadow .218s;
  vertical-align: middle;
  white-space: nowrap;
  width: auto;
  width: 100%;
  min-width: min-content;
}

.gsi-material-button .gsi-material-button-icon {
  height: 20px;
  margin-right: 12px;
  min-width: 20px;
  width: 20px;
}

.gsi-material-button .gsi-material-button-content-wrapper {
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  -webkit-flex-direction: row;
  flex-direction: row;
  -webkit-flex-wrap: nowrap;
  flex-wrap: nowrap;
  height: 100%;
  justify-content: space-between;
  position: relative;
  width: 100%;
}

.gsi-material-button .gsi-material-button-contents {
  margin-left: -30px;
  -webkit-flex-grow: 1;
  flex-grow: 1;
  font-family: 'Roboto', arial, sans-serif;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
}

.gsi-material-button .gsi-material-button-state {
  -webkit-transition: opacity .218s;
  transition: opacity .218s;
  bottom: 0;
  left: 0;
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.gsi-material-button:disabled {
  cursor: default;
  background-color: #ffffff61;
  border-color: #1f1f1f1f;
}

.gsi-material-button:disabled .gsi-material-button-contents {
  opacity: 38%;
}

.gsi-material-button:disabled .gsi-material-button-icon {
  opacity: 38%;
}

.gsi-material-button:not(:disabled):active .gsi-material-button-state, 
.gsi-material-button:not(:disabled):focus .gsi-material-button-state {
  background-color: #303030;
  opacity: 12%;
}

.gsi-material-button:not(:disabled):hover {
  -webkit-box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
  box-shadow: 0 1px 2px 0 rgba(60, 64, 67, .30), 0 1px 3px 1px rgba(60, 64, 67, .15);
}

.gsi-material-button:not(:disabled):hover .gsi-material-button-state {
  background-color: #303030;
  opacity: 8%;
}


</style>
